export default "__VITE_ASSET__Y6fKg13K__"